var _defs, _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrustRadiusLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 130.15 83.9062",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0 -84 -16.28 0 1253.59 19368)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient",
    x1: 229.57,
    x2: 230.57,
    y1: 74.06,
    y2: 74.06
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#116bf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e50e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0 -84 -16.28 0 1277.59 19368)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient_2",
    x1: 229.57,
    x2: 230.57,
    y1: 74.06,
    y2: 74.06
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#116bf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e50e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(39 39 46.97 -46.97 -11415 -6041.52)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient_3",
    x1: 225.45,
    x2: 226.45,
    y1: 57.72,
    y2: 57.72
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#116bf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185dec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0 -53.28 -56.7 0 3722.77 12301.9)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient_4",
    x1: 229.9,
    x2: 230.9,
    y1: 64.03,
    y2: 64.03
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#116bf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e50e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(-16 16 16 16 2980.5 -4568)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient_5",
    x1: 234.66,
    x2: 235.66,
    y1: 50.78,
    y2: 50.78
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#59c5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#21b1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(16 16 16 -16 -4307 -2664)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient_6",
    x1: 220.35,
    x2: 221.35,
    y1: 53.68,
    y2: 53.68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#59c5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#21b1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(-12 -12 -12 12 3802 2129.47)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient_7",
    x1: 240.54,
    x2: 241.54,
    y1: 66.86,
    y2: 66.86
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#57c4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#21b1ff"
  })))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ArtboardFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 83.9062,
    width: 130.15,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ArtboardFrame)",
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0.35C40.326 0.501623 40.6236 0.707936 40.88 0.96L55.11 15.2C55.6764 15.7604 55.9967 16.5232 56 17.32L56 82.91C55.9983 83.3119 55.7562 83.6737 55.3854 83.8286C55.0145 83.9835 54.587 83.9013 54.3 83.62L40.87 70.21C40.3109 69.6463 39.998 68.8839 40 68.09L40 0.35Z",
    fill: "url(#LinearGradient)",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.13 1C79.378 0.73221 79.6729 0.511935 80 0.35L80 68.08C80.002 68.8788 79.6852 69.6455 79.12 70.21L65.7 83.62C65.4156 83.899 64.9928 83.9825 64.6236 83.8327C64.2545 83.6829 64.0095 83.3283 64 82.93L64 17.3C64.0085 16.5199 64.3206 15.7738 64.87 15.22L64.87 15.22L79.11 1L79.13 1Z",
    fill: "url(#LinearGradient_2)",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 53.08L104 52.08L104 38.08L90.41 38.08C90.1477 38.0811 89.8963 38.1853 89.71 38.37L89.71 38.37L80 48.08L111.11 79.2L111.11 79.2C111.673 79.753 112.431 80.062 113.22 80.06L129.56 80.06C129.962 80.0583 130.324 79.8162 130.479 79.4454C130.634 79.0745 130.551 78.647 130.27 78.36L105 53.08Z",
    fill: "url(#LinearGradient_3)",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.24 0.08C80.4423 0.0939056 79.683 0.424971 79.13 1L79.13 1L64.87 15.2L64.87 15.2C64.6236 15.4514 64.4209 15.742 64.27 16.06L104 16.06L104 52.06L105 53.06L119.11 39C119.673 38.4379 119.989 37.6754 119.99 36.88L119.99 17.33C119.989 16.5346 119.673 15.7721 119.11 15.21L104.87 1C104.308 0.43723 103.545 0.1207 102.75 0.12L81.24 0.08Z",
    fill: "url(#LinearGradient_4)",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.87 1C40.3145 0.422531 39.5512 0.0912541 38.75 0.0800001L1.41 0.0800001C1.00373 0.0776376 0.63642 0.321304 0.480629 0.696519C0.324838 1.07173 0.41154 1.50391 0.7 1.79L14.11 15.2C14.6721 15.7628 15.4346 16.0793 16.23 16.08L54 16.08C55.1046 16.08 56 16.9754 56 18.08L56 17.33C55.9993 16.5346 55.6828 15.7721 55.12 15.21L40.87 1Z",
    fill: "url(#LinearGradient_5)",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.11 1C79.6679 0.420077 80.4353 0.0885884 81.24 0.08L102.75 0.08C103.545 0.0807002 104.308 0.39723 104.87 0.96L119.11 15.2C119.675 15.7645 119.992 16.5312 119.99 17.33L119.99 18.08C119.99 16.9754 119.095 16.08 117.99 16.08L66 16.08C64.8954 16.08 64 16.9754 64 18.08L64 17.33C64.0007 16.5346 64.3172 15.7721 64.88 15.21L79.11 1Z",
    fill: "url(#LinearGradient_6)",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 36.08C120 37.1846 119.105 38.08 118 38.08L91.2 38.08C90.9955 38.0788 90.8109 38.2021 90.7339 38.3915C90.6568 38.5809 90.7028 38.7981 90.85 38.94L105 53.08L119.12 39C119.683 38.4379 119.999 37.6754 120 36.88L120 36.08Z",
    fill: "url(#LinearGradient_7)",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustRadiusLogo);
export default __webpack_public_path__ + "../static/product-reviews/assets/trust-radius-logo.33476b8c03fd644f76dc22e82500608c.svg";
export { ForwardRef as ReactComponent };